/**
 * Phone number validation utilities (shared between frontend and backend).
 */

/**
 * Validates phone number format.
 * Accepts: (123) 456-7890, 123-456-7890, 1234567890, +1-123-456-7890, etc.
 */
export function isValidPhone(phone: string | null | undefined): boolean {
  if (!phone) {
    return false;
  }

  const digitsOnly = phone.replace(/\D/g, '');

  if (digitsOnly.length < 10 || digitsOnly.length > 15) {
    return false;
  }

  const phoneRegex =
    /^[\+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,4}[-\s.]?[0-9]{1,9}$/;

  if (!phoneRegex.test(phone)) {
    return false;
  }

  if (/^(\d)\1+$/.test(digitsOnly)) {
    return false;
  }

  const isSequential = digitsOnly.split('').every((digit, i, arr) => {
    if (i === 0) {
      return true;
    }
    return parseInt(digit, 10) === parseInt(arr[i - 1], 10) + 1;
  });
  if (isSequential) {
    return false;
  }

  return true;
}

export const PHONE_VALIDATION_MESSAGE =
  'Please enter a valid phone number (at least 10 digits)';
